module.exports = __webpack_public_path__ + "img/yuanhuizhen.40d03151.png";